import { queryOptions } from '@tanstack/react-query'
import getOrderList from '../api/get-order-list'

export const CURRENT_ORDERS_QUERY_KEY = ['orders', 'current'] as const

export const currentOrdersQueryOptions = queryOptions({
  queryKey: CURRENT_ORDERS_QUERY_KEY,
  queryFn: () => getOrderList({ isCurrent: true }),
})
